module.exports = __webpack_public_path__ + "static/img/25.28a011e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/25.png
// module id = IChz
// module chunks = 1